import useTranslation from '@space-core/hooks/useTranslation'

import { NotifyAnimation } from './styles'

import { Timer } from '../timer'

export type AccessCallProps = {
  isSessionInProgress: boolean
  durationSeconds: number
}

const AccessCall = ({ isSessionInProgress, durationSeconds }: AccessCallProps) => {
  const { t } = useTranslation()

  return (
    <>
      {isSessionInProgress ? (
        <>
          <NotifyAnimation className='container _w-auto _mr-2'>
            <div className='circle'></div>
          </NotifyAnimation>
          <span className='_text-gray-900 _text-1'>{t('mentorship.session_card.in_progress')}</span>
        </>
      ) : (
        <Timer duration={durationSeconds} />
      )}
    </>
  )
}

export default AccessCall
